import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './style.css';
import { getToken } from '../../../utils/tokenService';

const OfferLetter = ({
  letterLabel = 'Offer Letter',
  listHeading = 'My Offer Letters',
  detailRoutePrefix = '/user_dashboard/offer-letter',
  letterType = 'offer'
}) => {
  const [offerLetters, setOfferLetters] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOfferLetters = async () => {
      const token = await getToken();
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/offer-letter/user/offer-letters`, {
          params: { letterType },
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setOfferLetters(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching offer letters:', error);
        setLoading(false);
      }
    };

    fetchOfferLetters();
  }, [letterType]);

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'accepted':
        return 'bg-success';
      case 'rejected':
        return 'bg-danger';
      case 'sent':
        return 'bg-info';
      case 'draft':
        return 'bg-secondary';
      default:
        return 'bg-warning';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'accepted':
        return 'Accepted';
      case 'rejected':
        return 'Rejected';
      case 'sent':
        return 'Sent';
      case 'draft':
        return 'Draft';
      default:
        return status;
    }
  };

  const toTitleCase = (value) => {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const splitCompanyForMobile = (value) => {
    const normalized = toTitleCase(value || "N/A");
    const words = normalized.split(/\s+/).filter(Boolean);
    if (words.length <= 2) {
      return { firstLine: normalized, secondLine: "" };
    }
    return {
      firstLine: words.slice(0, 2).join(" "),
      secondLine: words.slice(2).join(" "),
    };
  };


  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>{`Loading ${letterLabel.toLowerCase()}s...`}</p>
      </div>
    );
  }

  return (
    <div className="container py-4 user-offer-letters-page">
      <div className="card shadow-sm">
        <div className="card-header bg-white border-bottom-0">
          <h3 className="mb-0">{listHeading}</h3>
        </div>
        <div className="card-body">
          {offerLetters.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted">{`No ${letterLabel.toLowerCase()}s found`}</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Position</th>
                    <th>Company</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {offerLetters.map((offer) => (
                    <tr key={offer._id}>
                      <td data-label="Position">
                        {offer?.hiringId?.job_category || offer?.jobCategory || 'N/A'}
                      </td>
                      <td data-label="Company">
                        {(() => {
                          const companyRaw =
                            offer?.establishmentId?.name || offer?.companyName || "N/A";
                          const company = splitCompanyForMobile(companyRaw);
                          return (
                            <span className="offer-company-text">
                              <span className="offer-company-line-1">{company.firstLine}</span>
                              {company.secondLine && (
                                <span className="offer-company-line-2">{company.secondLine}</span>
                              )}
                            </span>
                          );
                        })()}
                      </td>
                      <td data-label="Status" style={{height: '45px'}}>
                        {/* <div > */}
                          <div className={`badge ${getStatusBadgeClass(offer.status)}`}>
                            {getStatusText(offer.status)}
                          </div>
                        {/* </div> */}
                      </td>
                      <td data-label="Date">
                        {offer.acceptanceDate 
                          ? new Date(offer.acceptanceDate).toLocaleDateString()
                          : new Date(offer.createdAt).toLocaleDateString()}
                      </td>
                      <td data-label="Action">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => navigate(`${detailRoutePrefix}/${offer._id}`)}
                        >
                          <FaEye className="me-1" />
                          Show
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfferLetter;
